import dynamic from 'next/dynamic'

import { LoaderFullscreen } from 'components/Loader'

export { default as sessionDialogsProps } from './sessionDialogs'

const SCPR_AUTH_WAYS_DIALOG = dynamic(() => import('dialogs/AuthDialogs/SCPRConnectDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})
const CONNECT_ACCOUNT_DIALOG = dynamic(() => import('dialogs/AuthDialogs/ConnectAccount'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const AUTH_CONFIRM_DIALOG = dynamic(() => import('dialogs/AuthDialogs/AuthConfirmDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const START_GAME_FLOW = dynamic(() => import('dialogs/StartGameDialog'), {
  ssr: false,
})

const USER_EXISTS_DIALOG = dynamic(() => import('src/dialogs/UserExistsDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const QUICK_PURCHASE_DIALOG = dynamic(() => import('dialogs/QuickPurchaseDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const PAYMENT_DIALOG = dynamic(() => import('dialogs/PaymentDialog'), { loading: LoaderFullscreen, ssr: false })
const PAYMENT_CVV_DIALOG = dynamic(() => import('dialogs/PaymentCvvDialog'), { loading: LoaderFullscreen, ssr: false })
const PAYMENT_ERROR_DIALOG = dynamic(() => import('dialogs/PaymentErrorDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const PAYMENT_THREE_DS_DIALOG = dynamic(() => import('dialogs/ThreeDSDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const SHOP_DIALOG = dynamic(() => import('dialogs/ShopDialog'), { loading: LoaderFullscreen, ssr: false })

const ORDER_CONFIRMATION_MESSAGE = dynamic(() => import('dialogs/OrderConfirmationMessage'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const RESET_PASSWORD_DIALOG = dynamic(() => import('dialogs/AuthDialogs/ResetPassword'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const LEVEL_UP_NOTIFICATION = dynamic(() => import('dialogs/LevelUpModal'), { loading: LoaderFullscreen, ssr: false })

const VIP_REWARDS_DIALOG = dynamic(() => import('dialogs/VIPRewardsDialog'), { loading: LoaderFullscreen, ssr: false })

const SMS_CONSENT_DIALOG = dynamic(() => import('src/dialogs/SmsConsentDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const CURRENCY_SWITCH_QUICKSTART = dynamic(() => import('dialogs/CurrencySwitcherQuickstart'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const VIP_SUBSCRIPTION = dynamic(() => import('dialogs/VIPSubscription'), { loading: LoaderFullscreen })
const VIP_SUBSCRIPTION_CONFIRM_DIALOG = dynamic(() => import('dialogs/VIPSuccessSubscription'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const EXTRA_GOLD_DIALOG = dynamic(() => import('dialogs/ExtraCoinsDialog'), { loading: LoaderFullscreen, ssr: false })

const CUSTOM_OFFER_DIALOG = dynamic(() => import('dialogs/CustomOfferDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const LOYALTY_INACTIVITY_DIALOG = dynamic(() => import('dialogs/LoyaltyInactivityDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const BINGO_CASH_PRIZES_DIALOG = dynamic(() => import('src/dialogs/BingoCashPrizesDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const DAILY_REWARD_DIALOG = dynamic(() => import('dialogs/DailyRewardDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const NOT_ENOUGH_FUNDS = dynamic(() => import('dialogs/NotEnoughFunds'), { loading: LoaderFullscreen, ssr: false })
const MINI_GAME_DIALOG = dynamic(() => import('dialogs/MiniGame'), { loading: LoaderFullscreen, ssr: false })
const MINI_GAME_WINNING_DIALOG = dynamic(() => import('dialogs/MiniGameWinDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const WELCOME_EMAIL_SEND_DIALOG = dynamic(() => import('dialogs/WelcomeMailSendDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const REWARD_DIALOG = dynamic(() => import('dialogs/RewardDialog'), { loading: LoaderFullscreen, ssr: false })
const VERIFICATION_KYC_DIALOG = dynamic(() => import('src/dialogs/VerificationKYCDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})
const LOCK_USER_DIALOG = dynamic(() => import('dialogs/LockUserDialog'), { loading: LoaderFullscreen, ssr: false })
const RESTRICT_USER_DIALOG = dynamic(() => import('dialogs/RestrictUserDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})
const VERIFICATION_IN_PROGRESS_DIALOG = dynamic(() => import('dialogs/VerificationInProgressDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})
const SOFT_KYC_DIALOG = dynamic(() => import('dialogs/SoftKycDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

// redeem dialogs
const SUBMIT_DOCUMENTS_DIALOG = dynamic(() => import('dialogs/RedeemFlow/SubmitDocuments'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const WITHDRAW_SWEEPSTSKE_DIALOG = dynamic(() => import('dialogs/RedeemFlow/ACHProvider/WithdrawSweepstake'), {
  loading: LoaderFullscreen,
  ssr: false,
})
const WITHDRAW_DIALOG = dynamic(() => import('dialogs/RedeemFlow'), {
  loading: LoaderFullscreen,
  ssr: false,
})
const WITHDRAW_PROVIDERS_DIALOG = dynamic(() => import('dialogs/RedeemFlow/ChooseProvider'), {
  loading: LoaderFullscreen,
  ssr: false,
})
const WITHDRAW_SWEEPSTSKE_TRUSTLY_DIALOG = dynamic(() => import('dialogs/RedeemFlow/TrustlyProviderRedeem'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const WITHDRAW_CONFIRM_EMAIL_DIALOG = dynamic(() => import('dialogs/RedeemFlow/ConfirmEmail'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const REDEEM_SUCCESSFUL_DIALOG = dynamic(() => import('dialogs/RedeemFlow/RedeemSuccessful/ACHSuccess'), {
  loading: LoaderFullscreen,
  ssr: false,
})
const PURCHASE_LIMIT_DIALOG = dynamic(() => import('dialogs/PurchaseLimitDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})
const SLOT_MAINTENANCE_DIALOG = dynamic(() => import('dialogs/SlotMaintenanceDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})
const PHONE_VERIFICATION_DIALOG = dynamic(() => import('dialogs/PhoneVerificationDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})
const PHONE_VERIFICATION_STATUS_DIALOG = dynamic(() => import('dialogs/PhoneVerificationStatusDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const SMS_CONSENT_STATUS_DIALOG = dynamic(() => import('dialogs/SmsConsentStatusDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const OTP_HELLO_AGAIN_DIALOG = dynamic(() => import('dialogs/OTPHelloAgain'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const GAME_NOT_FOR_SC_DIALOG = dynamic(() => import('src/dialogs/GameNotForSCDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const GAME_ONLY_FOR_INFINITE_DIALOG = dynamic(() => import('src/dialogs/GameOnlyForInfiniteDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const PRELOADER_DIALOG = dynamic(() => import('src/dialogs/PreloaderDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const GET_VERIFIED_DIALOG = dynamic(() => import('src/dialogs/GetVerifiedDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})
const LEGALS_MODAL = dynamic(() => import('src/dialogs/LegalsModal'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const FREE_SPINS_DIALOG = dynamic(() => import('src/dialogs/FreeSpinsDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const VERIFY_INFO_DIALOG = dynamic(() => import('src/dialogs/VerifyInfoDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const JACKPOTS_PROMO_DIALOG = dynamic(() => import('src/dialogs/JackpotDialogs/JackpotsPromo'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const JACKPOTS_OPT_IN_DIALOG = dynamic(() => import('src/dialogs/JackpotDialogs/OptIn'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const JACKPOTS_OPT_OUT_DIALOG = dynamic(() => import('src/dialogs/JackpotDialogs/OptOut'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const JACKPOTS_MY_STASH_WAITING_DIALOG = dynamic(() => import('src/dialogs/JackpotDialogs/MyStashWaiting'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const JACKPOTS_MY_STASH_UNLOCKED_DIALOG = dynamic(() => import('src/dialogs/JackpotDialogs/MyStashUnlocked'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const JACKPOTS_GOLD_MINE_WIN_DIALOG = dynamic(() => import('src/dialogs/JackpotDialogs/GoldMineWin'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const LOW_COINS_DIALOG = dynamic(() => import('src/dialogs/LowCoinsDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const USER_BEEN_LOGGED_IN_DIALOG = dynamic(() => import('src/dialogs/UserBeenLoggedInDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const JUMIO_CARD_VERIFICATION_STATUS_DIALOG = dynamic(
  () => import('src/dialogs/JumioCardVerificationDialogs/StatusDialog'),
  {
    loading: LoaderFullscreen,
    ssr: false,
  },
)

const INSUFFICIENT_FUNDS = dynamic(() => import('dialogs/InsufficientFundsDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const DELETE_PAYMENT_METHOD_DIALOG = dynamic(() => import('src/dialogs/DeletePaymentMethodDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const DAILY_REWARD_SUCCESS_DIALOG = dynamic(() => import('src/dialogs/DailyRewardSuccessDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const LOYALTY_LEVEL_UP_DIALOG = dynamic(() => import('dialogs/LoyaltyLevelUpDialog'), {
  loading: LoaderFullscreen,
  ssr: false,
})

const dialogs = {
  START_GAME_FLOW,
  PAYMENT_DIALOG,
  PAYMENT_CVV_DIALOG,
  PAYMENT_ERROR_DIALOG,
  PAYMENT_THREE_DS_DIALOG,
  SHOP_DIALOG,
  ORDER_CONFIRMATION_MESSAGE,
  SCPR_AUTH_WAYS_DIALOG,
  CONNECT_ACCOUNT_DIALOG,
  RESET_PASSWORD_DIALOG,
  SUBMIT_DOCUMENTS_DIALOG,
  WITHDRAW_SWEEPSTSKE_DIALOG,
  WITHDRAW_DIALOG,
  WITHDRAW_PROVIDERS_DIALOG,
  WITHDRAW_CONFIRM_EMAIL_DIALOG,
  WITHDRAW_SWEEPSTSKE_TRUSTLY_DIALOG,
  REDEEM_SUCCESSFUL_DIALOG,
  AUTH_CONFIRM_DIALOG,
  USER_EXISTS_DIALOG,
  LEVEL_UP_NOTIFICATION,
  VIP_REWARDS_DIALOG,
  SMS_CONSENT_DIALOG,
  SMS_CONSENT_STATUS_DIALOG,
  VIP_SUBSCRIPTION,
  EXTRA_GOLD_DIALOG_SESSION: EXTRA_GOLD_DIALOG,
  EXTRA_GOLD_DIALOG,
  VIP_SUBSCRIPTION_CONFIRM_DIALOG,
  CURRENCY_SWITCH_QUICKSTART,
  DAILY_REWARD_DIALOG,
  NOT_ENOUGH_FUNDS,
  MINI_GAME_DIALOG,
  MINI_GAME_WINNING_DIALOG,
  WELCOME_EMAIL_SEND_DIALOG,
  REWARD_DIALOG,
  VERIFICATION_KYC_DIALOG,
  LOCK_USER_DIALOG,
  VERIFICATION_IN_PROGRESS_DIALOG,
  SOFT_KYC_DIALOG,
  PURCHASE_LIMIT_DIALOG,
  SLOT_MAINTENANCE_DIALOG,
  PHONE_VERIFICATION_DIALOG,
  PRELOADER_DIALOG,
  PHONE_VERIFICATION_STATUS_DIALOG,
  GET_VERIFIED_DIALOG,
  LEGALS_MODAL,
  OTP_HELLO_AGAIN_DIALOG,
  GAME_NOT_FOR_SC_DIALOG,
  GAME_ONLY_FOR_INFINITE_DIALOG,
  FREE_SPINS_DIALOG,
  RESTRICT_USER_DIALOG,
  VERIFY_INFO_DIALOG,
  JACKPOTS_PROMO_DIALOG,
  JACKPOTS_OPT_IN_DIALOG,
  JACKPOTS_OPT_OUT_DIALOG,
  JACKPOTS_MY_STASH_WAITING_DIALOG,
  JACKPOTS_MY_STASH_UNLOCKED_DIALOG,
  JACKPOTS_GOLD_MINE_WIN_DIALOG,
  LOW_COINS_DIALOG,
  BINGO_CASH_PRIZES_DIALOG,
  USER_BEEN_LOGGED_IN_DIALOG,
  JUMIO_CARD_VERIFICATION_STATUS_DIALOG,
  QUICK_PURCHASE_DIALOG,
  INSUFFICIENT_FUNDS,
  DELETE_PAYMENT_METHOD_DIALOG,
  DAILY_REWARD_SUCCESS_DIALOG,
  CUSTOM_OFFER_DIALOG,
  LOYALTY_LEVEL_UP_DIALOG,
  LOYALTY_INACTIVITY_DIALOG,
}

export type DialogNames = keyof typeof dialogs

export default dialogs
